export default __webpack_public_path__ + "static/media/banner-home7.0383954a.png";